import { render, staticRenderFns } from "./city.vue?vue&type=template&id=3522b9ac&scoped=true&"
import script from "./city.vue?vue&type=script&lang=js&"
export * from "./city.vue?vue&type=script&lang=js&"
import style0 from "./city.vue?vue&type=style&index=0&id=3522b9ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3522b9ac",
  null
  
)

export default component.exports